import React from "react";
import { useLocation } from "react-router-dom";
import { Chip, Divider, Box, Typography, Container, Button, Card, CardActions, CardContent, CardMedia, Grid, Zoom } from "@mui/material";
import Footer from "../components/Footer";
import { db } from "../config/firebase/config";

export default function Projects() {
  const location = useLocation();

  const [loading, setLoading] = React.useState(false);
  const [projects, setProjects] = React.useState([]);

  const [startAnimation, setStartAnimation] = React.useState(false);

  const cargarImagen = (entrada, observador) => {
    entrada.forEach((x) => {
      if (x.isIntersecting) {
        document.getElementById("containerProjects").style.visibility = "visible";
        setStartAnimation(true);
      }
    });
  };

  React.useEffect(() => {
    if (loading) {
      if (document.getElementById("containerProjects")) {
        let containerSkills = document.getElementById("containerProjects");
        const observador = new IntersectionObserver(cargarImagen, { root: null, rootMargin: "0px", threshold: 0.1 });
        observador.observe(containerSkills);
      }
    } else {
      db.collection("projects").onSnapshot((data) => {
        setProjects(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        setLoading(true);
      });
    }
  }, [loading]);

  return (
    <>
      <Container sx={{ pt: { xs: 10, sm: 12 }, pb: { xs: 10, sm: 12 }, minHeight: "100vh" }}>
        <Container disableGutters maxWidth="lg" id="containerProjects" style={{ visibility: "hidden" }}>
          {loading ? (
            <>
              <Zoom in={startAnimation} timeout={1000}>
                <Typography variant="h3" component="h2" textAlign="center" color="primary" sx={{ pb: 5 }}>
                  PORTFOLIO
                </Typography>
              </Zoom>
              <Grid container spacing={3} rowSpacing={4}>
                {projects.map((data, index) =>
                  data.state ? (
                    <Grid item key={data.id} xs={12} sm={6} md={4}>
                      <Zoom in={startAnimation} timeout={3000} style={{ transitionDelay: (index + 1) * 1000 }}>
                        {/* Card raised */}
                        <Card
                          variant="outlined"
                          sx={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <CardMedia component="img" alt={data.name} title={data.name} image={data.img} />
                          <CardContent sx={{ flexGrow: 1 }}>
                            <Typography variant="h6" component="h2">
                              {data.name}
                            </Typography>

                            <Divider sx={{ mt: 1, mb: 1 }} light />

                            <Typography>{data.description}</Typography>

                            <Divider sx={{ mt: 1, mb: 1 }} light />

                            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                              {data.tags.map((tag) => (
                                <Chip size="small" key={tag} label={tag} variant="outlined" sx={{ mt: 1, mr: 1 }} />
                              ))}
                            </Box>
                          </CardContent>

                          <Divider variant="middle" light />

                          <CardActions sx={{ justifyContent: "space-evenly", rowGap: 1 }}>
                            <Button rel="noreferrer" target="_blank" variant="contained" href={data.url} sx={{ mt: 1, mb: 1 }} className="jello-horizontal">
                              Website
                            </Button>
                            <Button rel="noreferrer" target="_blank" variant="contained" href={data.repository} sx={{ mt: 1, mb: 1 }} className="jello-horizontal">
                              Repository
                            </Button>
                          </CardActions>
                        </Card>
                      </Zoom>
                    </Grid>
                  ) : null
                )}
              </Grid>{" "}
            </>
          ) : null}
        </Container>
      </Container>

      {location.pathname === "/" || location.pathname === "/home" ? null : <Footer />}
    </>
  );
}
